import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Navigate } from 'react-router-dom';
import LoginPage from './LoginPage';
import InitialScreen from './InitialScreen';
import RegistrationPage from './RegistrationPage';
import QuestionList from './QuestionList';

function App() {
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  }

  return (
    <Router>
      <div className="App">
        <header className="App-header">
          

          <Routes>
            <Route path="/" element={<InitialScreen />} />
            <Route
              path="/login"
              element={<LoginPage onLoginSuccess={handleLoginSuccess} />}
            />
            <Route path="/register" element={<RegistrationPage />} />
            <Route
              path="/question-list"
              element={<QuestionList />}
            />
          </Routes>
        </header>
      </div>
    </Router>
  );
}

export default App;
